import Flex from '@components/Flex/Flex';
import Text from '@components/Text/Text';
import { styled } from '@mui/material';

export const Container = styled(Flex)(({ theme }) => ({
  backgroundColor: theme.palette.grey[100],
  padding: theme.spacing(8),
  border: `1px solid ${theme.palette.grey[500]}`,
  borderRadius: theme.spacing(5),
  alignItems: 'center',
  [theme.breakpoints.down('md')]: {
    flexDirection: 'column',
    alignItems: 'flex-start',
  },
}));

export const StyledLabel = styled(Text)(({ theme }) => ({
  color: theme.palette.text.primary,
  width: 230,
  minWidth: 230,
  marginRight: theme.spacing(3),
  alignSelf: 'flex-start',
  flexWrap: 'wrap',
}));

export const StyledValueContainer = styled(Flex)(({ theme }) => ({
  flexWrap: 'wrap',
  flexDirection: 'column',
  [theme.breakpoints.down('md')]: {
    flexDirection: 'column',
    marginTop: theme.spacing(3),
  },
}));

export const StyledMultiValue = styled(Text)(({ theme }) => ({
  minWidth: 200,
  flexWrap: 'wrap',
  marginRight: theme.spacing(3),
}));
